<div class="registrar-se-container">
    <mat-toolbar color="secondary" class="toolbar">
        <span></span>
    </mat-toolbar>

    <mat-card class="card">
        <mat-card-header class="header">
            <mat-card-title class="title">{{ "REGISTER_THIRDPARTY.TITLE" | translate }}</mat-card-title>
            <mat-card-subtitle class="subtitle">
                {{ "REGISTER_THIRDPARTY.SUBTITLE" | translate }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-vertical-stepper linear #stepper class="mat-primary stepper">
                <mat-step>
                    <form>
                        <ng-template matStepLabel>
                            {{ "REGISTER_THIRDPARTY.CATEGORIES.TITLE" | translate }}
                        </ng-template>

                        <h5>
                            {{ "REGISTER_THIRDPARTY.CATEGORIES.SUBTITLE" | translate }}
                        </h5>

                        <mat-chip-list [multiple]="true">
                            <mat-chip
                                *ngFor="let tag of tags"
                                (click)="selectMainTag(tag.id)"
                                [selected]="tag.selected"
                            >
                                {{ tag.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_CategoriasVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER_THIRDPARTY.CATEGORIES.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_CategoriasProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER_THIRDPARTY.CATEGORIES.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step>
                    <form>
                        <ng-template matStepLabel>
                            {{ "REGISTER_THIRDPARTY.SUBCATEGORIES.TITLE" | translate }}
                        </ng-template>

                        <h5>
                            {{ "REGISTER_THIRDPARTY.SUBCATEGORIES.SUBTITLE" | translate }}
                        </h5>

                        <mat-chip-list *ngFor="let tag of getSelectedTags()" style="margin-top: 25px" [multiple]="true">
                            <p style="width: 100%; text-align: center">
                                {{ tag.nome }}
                            </p>

                            <mat-chip
                                *ngFor="let child of tag.subCategorias"
                                (click)="selectChildrenTag(tag.id, child.id)"
                                [selected]="child.selected"
                                style="margin-top: 10px; margin-bottom: 15px"
                            >
                                {{ child.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_SubcategoriasVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER_THIRDPARTY.SUBCATEGORIES.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_Subcategorias_proximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER_THIRDPARTY.SUBCATEGORIES.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <!-- as senhas serão os últimos steps -->
                <mat-step>
                    <ng-template matStepLabel>
                        {{ "REGISTER_THIRDPARTY.PASSWORD.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER_THIRDPARTY.PASSWORD.SUBTITLE" | translate }}
                    </h5>

                    <app-password-validator
                            [passwordRegex]="getPasswordRegex()"
                            [passwordCustomRules]="getPasswordCustomRules()"
                            (validValue)="validPassword($event)"
                            (password)="password($event)"
                        ></app-password-validator>

                    <div class="stepperNavButtons">
                        <button
                            [id]="'button_registrar_SenhaVoltar'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                        >
                            {{ "REGISTER_THIRDPARTY.PASSWORD.ACTIONS.BACK" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_SenhaProximo'"
                            mat-stroked-button
                            color="primary"
                            matStepperNext
                            [disabled]="!_validPassword"
                        >
                            {{ "REGISTER_THIRDPARTY.PASSWORD.ACTIONS.NEXT" | translate }}
                        </button>
                    </div>
                </mat-step>

                <mat-step [stepControl]="termosUsoFormGroup">
                    <form [formGroup]="termosUsoFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER_THIRDPARTY.TERMS_OF_USE.TITLE" | translate }}
                        </ng-template>

                        <button mat-stroked-button (click)="openTermsOfUseDialog()">
                            {{ "REGISTER.TERMS_OF_USE.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            (change)="onChange($event, stepper)"
                            #toggleTermosUso
                            color="primary"
                            formControlName="aceitoTermos"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!TermsOfUseClicked"
                        >
                            {{ "REGISTER_THIRDPARTY.TERMS_OF_USE.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>

                <mat-step [stepControl]="politicaPrivacidadeFormGroup">
                    <form [formGroup]="politicaPrivacidadeFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER_THIRDPARTY.PRIVACY_POLICY.TITLE" | translate }}
                        </ng-template>

                        <button mat-stroked-button (click)="openPrivacyPoliceDialog()">
                            {{ "REGISTER.PRIVACY_POLICY.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            (change)="onChange($event, stepper)"
                            #togglePoliticaPrivacida
                            color="primary"
                            formControlName="concordoPoliticaPrivacidade"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!privacyPolicyClicked"
                        >
                            {{ "REGISTER_THIRDPARTY.PRIVACY_POLICY.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>

                <mat-step>
                    <ng-template matStepLabel>
                        {{ "REGISTER_THIRDPARTY.DONE.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER_THIRDPARTY.DONE.SUBTITLE" | translate }}
                    </h5>

                    <div [hidden]="!error" class="alert alert-warning">
                        {{ error }}
                    </div>
                    <div [hidden]="!errorApi" class="alert alert-warning">
                        {{ errorApi }}
                    </div>

                    <div [hidden]="!success" class="alert alert-info">
                        {{ success }}
                    </div>

                    <div class="stepperNavButtons">
                        <button
                            [id]="'button_registrar_FeitoVoltar'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                            *ngIf="!cadastrado"
                        >
                            {{ "REGISTER_THIRDPARTY.DONE.ACTIONS.BACK" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_FeitoCadastrar'"
                            mat-flat-button
                            color="primary"
                            (click)="cadastrarUsuario()"
                            [disabled]="isLoading || !toggleTermosUso.checked"
                            [class.spinner]="isLoading"
                            *ngIf="!cadastrado"
                        >
                            {{ "REGISTER_THIRDPARTY.DONE.ACTIONS.REGISTER" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_FeitoIniciar'"
                            mat-flat-button
                            color="primary"
                            (click)="login()"
                            [disabled]="isLoading"
                            *ngIf="cadastrado"
                            [class.spinner]="isLoading"
                        >
                            {{ "REGISTER_THIRDPARTY.DONE.ACTIONS.BEGIN" | translate }}
                        </button>
                    </div>
                </mat-step>
            </mat-vertical-stepper>
        </mat-card-content>
    </mat-card>
</div>
